import React, { useState, useEffect } from 'react'
import { T, Spinner, Empty, Avatar, probColor } from '../ui'
import { getNFLPickemBoard } from '../api'
import { teamNick } from '../plain'

// Pick'em / DFS +EV board — every PrizePicks / Underdog / Pick6 line vs the model's probability
// AT that line, flagged against the 2-pick-power break-even (~57.7%). Model edge, not profit.
// Populates once NFL_DFS_LINES is on and lines have been pulled.
const APP_COLOR = { PrizePicks: '#7A3BFF', Underdog: '#FF6B35', 'DK Pick6': '#00B46E', Dabble: '#2E8BFF' }

function Row({ p }) {
  const over = p.side === 'over'
  const prob = Math.round((p.prob || 0) * 100)
  const edge = Math.round((p.edge || 0) * 100)
  const appc = APP_COLOR[p.app] || T.muted2
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, background: T.card,
      border: `1px solid ${p.plus_ev ? T.greenMid : T.border}`, borderRadius: 12, padding: '10px 12px', marginBottom: 8 }}>
      <Avatar url={p.headshot} name={p.name} team={p.team} size={34} />
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ fontSize: 13.5, fontWeight: 800, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {p.name} <span style={{ fontSize: 10, color: T.muted, fontWeight: 700 }}>{p.pos}</span>
        </div>
        <div style={{ fontSize: 10.5, color: T.muted, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', marginTop: 1 }}>
          <span style={{ color: appc, fontWeight: 800 }}>{p.app}</span> · {p.market}{p.opp ? ` · vs ${teamNick(p.opp)}` : ''}
        </div>
      </div>
      <div style={{ textAlign: 'center', flexShrink: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 900, color: over ? T.green : T.amber, lineHeight: 1 }}>
          {over ? 'OVER' : 'UNDER'}</div>
        <div style={{ fontSize: 11, color: T.text, fontFamily: T.mono, marginTop: 2 }}>{p.dfs_line}</div>
        {p.line_gap ? <div style={{ fontSize: 10, color: T.muted, marginTop: 1 }}>
          {p.line_gap > 0 ? '+' : ''}{p.line_gap} vs model</div> : null}
      </div>
      <div style={{ textAlign: 'right', flexShrink: 0, minWidth: 56 }}>
        <div style={{ fontFamily: T.mono, fontWeight: 900, fontSize: 17, lineHeight: 1, color: probColor(p.prob || 0) }}>{prob}%</div>
        <div style={{ fontSize: 10, color: p.plus_ev ? T.green : T.muted, fontWeight: 800, marginTop: 2 }}>
          {p.plus_ev ? `+${edge}pt EV` : `${edge}pt`}</div>
      </div>
    </div>
  )
}

export default function PickemTab({ season = 2026, week = 1 }) {
  const [d, setD] = useState(null)
  useEffect(() => { let a = true; setD(null)
    getNFLPickemBoard(season, week).then(r => { if (a) setD(r) }); return () => { a = false } }, [season, week])
  const plays = d?.plays || []
  const plusEv = plays.filter(p => p.plus_ev).length
  return (
    <div style={{ padding: '12px 16px 80px' }}>
      <div style={{ fontSize: 12, color: T.muted, lineHeight: 1.5, marginBottom: 12 }}>
        <b style={{ color: T.text }}>+EV for your pick'em slate.</b> Every PrizePicks / Underdog / Pick6 line vs. the model's
        probability at that line — flagged when it clears the 2-pick-power break-even (<b style={{ color: T.text }}>~58%</b>).
        Model edge, not profit · research only · 21+.
      </div>
      {!d ? <Spinner />
        : plays.length === 0 ? (
          <Empty message={d.dfs_enabled
            ? 'No pick’em lines pulled for this week yet — check back after lines post.'
            : 'Pick’em lines aren’t available yet — this board fills in once PrizePicks / Underdog lines are posted.'} />
        ) : (<>
          <div style={{ fontSize: 11, color: T.muted, marginBottom: 10 }}>
            <b style={{ color: T.green }}>{plusEv}</b> +EV spot{plusEv === 1 ? '' : 's'} · {plays.length} lines
          </div>
          {plays.map((p, i) => <Row key={`${p.gsis_id}-${p.app_key}-${p.prop_type}-${i}`} p={p} />)}
        </>)}
    </div>
  )
}
